import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ContentBorderShadowUIComponent } from '../../content-border-shadow/content-border-shadow.component';

export const CustomerViewTabItemFit = { Auto: 'auto', Full: 'full' } as const;
export type CustomerViewTabItemFit =
  (typeof CustomerViewTabItemFit)[keyof typeof CustomerViewTabItemFit];

export type CustomerViewTabItemSize = number | CustomerViewTabItemFit;

@Component({
  selector: 'fr8bot-business-view-tab-item',
  imports: [ContentBorderShadowUIComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './business-view-tab-item.component.html',
  styleUrl: './business-view-tab-item.component.scss',
  // TODO: optional
  //   тут по-ідеї можна просто зверху тейлвіед навісити класс, де це треба
  host: {
    '[style.--tab-item-flex]': 'flex()',
    '[class.customer-view-tab-item--variant-modal]': 'variantModal()',
  },
})
export class BusinessViewTabItemComponent {
  size = input<CustomerViewTabItemSize>(CustomerViewTabItemFit.Full);
  variantModal = input(false);

  protected readonly flex = computed(() => {
    const size = this.size();

    if (size === CustomerViewTabItemFit.Full) {
      return '1 0 auto';
    }

    if (size === CustomerViewTabItemFit.Auto) {
      return '0 0 auto';
    }

    return `0 0 ${size}px`;
  });
}
